var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Disapproval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 25.5a5.45 5.45 0 01-1.26 3.5 5.49 5.49 0 010 7A5.45 5.45 0 0168 39.5a5.51 5.51 0 01-5.5 5.5H47v15.5a5.5 5.5 0 01-11 0V58c0-7.53-5-13-12-13h-5a2 2 0 01-2-2V19a2 2 0 012-2h5.47L31 13.26a2 2 0 011-.26h20.5a5.51 5.51 0 015.5 5.5 5.719 5.719 0 01-.21 1.5h4.71a5.51 5.51 0 015.5 5.5zm-4 0a1.5 1.5 0 00-1.5-1.5H47a2 2 0 010-4h5.5a1.5 1.5 0 100-3h-20L26 20.74c-.305.173-.65.263-1 .26h-4v20h3c9.12 0 16 7.31 16 17v2.5a1.5 1.5 0 103 0V41h19.5a1.5 1.5 0 100-3H47a2 2 0 010-4h15.5a1.5 1.5 0 100-3H47a2 2 0 010-4h15.5a1.5 1.5 0 001.5-1.5zM11 17a3 3 0 00-3 3v22a3 3 0 106 0V20a3 3 0 00-3-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Disapproval.0902ac43.svg";
export { SvgK1Disapproval as ReactComponent };